import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepDeclaration = (state) => state.get('stepDeclaration');

const makeSelectStepDeclaration = () => createSelector(
  selectStepDeclaration,
  (stepDeclarationState) => ({
    signature: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'signature']), ''),
    emailAddress: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'emailAddress']), ''),
    electronicConsentDocument: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'electronicConsentDocument']), ''),
    validateFromData: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'validateFromData']), ''),
    declarationSignature: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'declarationSignature']), ''),
    privacyActAuthorisationSignature: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'privacyActAuthorisationSignature']), ''),
    warningMissingRequiredDocument: mapWithDefault(stepDeclarationState, () => stepDeclarationState.getIn(['form', 'warningMissingRequiredDocument']), ''),
  }),
);

export {
  makeSelectStepDeclaration,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/selectors.js